<!-- partial:navbar -->
<ideapa-navbar [hideNavbar]="(hideNav$ | ngrxPush) || false"></ideapa-navbar>
@if (currentModulo$ | ngrxPush; as modulo) {
  <div
    class="module-navbar"
    [style.background-color]="modulo.colore"
    >
    <div class="nome-modulo">
      {{ modulo.nome }}
    </div>
    @if (currentEnte$ | ngrxPush; as ente) {
      <button
        class="btn nome-ente"
        (click)="showSelectModulo()"
        >
        <span class="material-symbols-outlined me-2"> domain </span>
        <span>{{ ente.descrizione }}</span>
      </button>
    }
    @if (currentAnno$ | ngrxPush; as anno) {
      <button
        class="btn nome-anno"
        (click)="showSelectModulo()"
        >
        <span class="material-symbols-outlined me-2"> calendar_today </span>
        <span> {{ anno }}</span>
      </button>
    }
    <ideapa-icon-button
      icon="close"
      class="ms-auto text-dark"
      (clicked)="clearModulo()"
      >
    </ideapa-icon-button>
  </div>
}
<!-- partial -->

<div class="main-wrapper" [class.hide-nav]="hideNav$ | ngrxPush">
  <!-- partial:sidebar -->
  <ideapa-sidebar [hidden]="hideNav$ | ngrxPush"></ideapa-sidebar>
  <!-- partial -->

  <div class="page-wrapper" [class.hide-nav]="hideNav$ | ngrxPush">
    <div class="page-content d-flex flex-column flex-grow-1">
      <!-- Spinner for lazyload modules -->
      <div [className]="isLoading ? 'spinner-wrapper' : 'd-none'">
        <div class="spinner">Loading...</div>
      </div>

      <div
        contentAnimate
        [className]="isLoading ? 'd-none' : 'd-flex flex-column flex-grow-1'"
        >
        <!--  -->
        @if (tabs$ | ngrxPush; as tabs) {
          @if (tabs.length) {
            <ul class="nav nav-tabs">
              @for (t of tabs; track t) {
                <!-- <li
                class="nav-item nav-item-bookmark"
                [style.background-color]="
                  t.modulo ? (currentModulo$ | ngrxPush)?.colore : undefined
                "
                [class.active]="rla.isActive"
              ></li> -->
              <li class="nav-item d-flex align-items-center" [title]="t.label">
                <div
                  class="nav-item-bookmark flex-shrink-0"
                  [style.background-color]="
                    t.modulo ? (currentModulo$ | ngrxPush)?.colore : undefined
                  "
                  [class.active]="rla.isActive"
                ></div>
                <a
                  class="nav-link d-flex align-items-center"
                  [class.active]="rla.isActive"
                  [routerLink]="[t.path]"
                  [id]="t.path"
                  routerLinkActive
                  #rla="routerLinkActive"
                  [routerLinkActiveOptions]="{ exact: false }"
                  >
                  <span class="tab-title">
                    {{ t.label }}
                  </span>
                  <ideapa-icon-button
                    icon="close"
                    [style.visibility]="
                      showClose(t, tabs) ? 'visible' : 'hidden'
                    "
                    cssClasses="text-primary hover-bg-primary"
                    class="ms-2"
                    (clicked)="closeTab(t.path, $event)"
                    >
                  </ideapa-icon-button>
                </a>
                <div
                  class="nav-item-triangle flex-shrink-0"
                  [class.active]="rla.isActive"
                ></div>
              </li>
              }</ul
              >
            }
          }

          <div class="tab-content d-flex flex-column flex-grow-1 content-panel">
            <!-- <ideapa-breadcrumb></ideapa-breadcrumb> -->
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>

      <!-- partial:footer -->
      <!-- <ideapa-footer></ideapa-footer> -->
      <!-- partial -->
    </div>
  </div>
